import { inject, injectable } from 'inversify';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { CacheTypenames, INotification, INotificationsService, INotification_input } from '@workbench-stack/core';
import { ClientTypes as CommonTypes } from '@common-stack/client-react';
import { NotificationsDocument } from '@workbench-stack/components/lib/editors';



@injectable()
export class NotificationService implements INotificationsService {
    constructor(
        @inject(CommonTypes.ApolloClient)
        protected client: ApolloClient<any>,
        @inject(CommonTypes.InMemoryCache)
        protected cache: InMemoryCache,
    ) {
    }

    public addNotification(notification: INotification_input) {
        let notifications;
        const newNotification = {
            ...notification,
            actions: notification.actions && {
                primary: notification.actions.primary.map((primary) => ({
                    ...primary,
                    run: {
                        ...primary.run,
                        __typename: CacheTypenames.ActionRun,
                    },
                    __typename: CacheTypenames.Action,
                })),
                secondary: notification.actions.secondary.map((secondary) => ({
                    ...secondary,
                    run: {
                        ...secondary.run,
                        __typename: CacheTypenames.ActionRun,
                    },
                    __typename: CacheTypenames.Action,
                })),
                __typename: CacheTypenames.Actions,
            },
            __typename: CacheTypenames.Notification,
        };

        try {
            const { notifications: existNotifications } = this.client.readQuery({
                query: NotificationsDocument,
            });
            notifications = [ ...existNotifications.notifications, newNotification];
        } catch (e) {
            notifications = [newNotification];
        }
        const notifications_input = {
            notifications: {
                notifications: notifications.map((item, index) => ({ ...item, index })),
                __typename: CacheTypenames.Notifications,
            },
        };
        this.client.writeQuery({
            query: NotificationsDocument,
            data: notifications_input,
        });
        return true;
    }

    public closeNotification(index: number) {
        const { notifications: notification } = this.client.readQuery({
            query: NotificationsDocument,
        });

        const notificationArray = notification.notifications.slice(0);
        notificationArray.splice(index, 1);

        const data = {
            notifications: {
                notifications: notificationArray.map((item, i) => ({ ...item, index: i })),
                __typename: CacheTypenames.Notifications,
            },
        };
        this.client.writeQuery({
            query: NotificationsDocument,
            data,
        });

        return true;
    }
}
